import { ComponentProps, ReactNode } from 'react'
import { Box, Text } from '@machobear/design-system'

interface Props {
  text: string
  tone?: ComponentProps<typeof Text>['tone']
  disabled?: boolean
  icon: ReactNode
  onClick: () => any
}

export const DropdownMenuItem = ({
  text,
  icon,
  onClick,
  tone = 'neutral',
  disabled = false
}: Props) => (
  <Box
    display="flex"
    flexDirection="row"
    alignItems="center"
    gap="xsmall"
    padding="xsmall"
    onClick={!disabled ? onClick : undefined}
    cursor="pointer"
  >
    <Box>{icon}</Box>
    <Text size="standard" tone={disabled ? 'disabled' : tone}>
      {text}
    </Text>
  </Box>
)
